<script>
import confirmDialog from '@/components/ConfirmDialog.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import TriageCard from '@/components/BaseInformation/ChiefComplaint/clinicalTriage/card.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import SharedHelper from '@/Helpers/Shared';
import pagination from '@/Mixins/Pagination';

import ChiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';

import AdviceGuidanceDTO from '@/Mixins/BaseInformation/ChiefComplaint/dto/adviceGuidance.dto';
import AdviceGuidanceHelper from '@/Helpers/BaseInformation/ChiefComplaint/adviceGuidance.helper';
import AdviceGuidanceMixin from '@/Mixins/BaseInformation/ChiefComplaint/adviceGuidance.mixin';

// import ClinicalTriageMixin from '@/Mixins/BaseInformation/ClinicalTriageMixin.js';

export default {
  name: 'ClinicalTriageManagment',
  title: 'توصیه و راهنمایی',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    AppPageContainer,
    TriageCard,
  },
  mixins: [
    pagination,
    ShearedMixin,
    AdviceGuidanceMixin,
    AdviceGuidanceHelper,
    SharedHelper,
    snackBar,
    ChiefComplaintMixin,
    AdviceGuidanceDTO,
  ],
  created() {
    this.$root.$refs.chiefComplaintAdviceGuidance = this;
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.chiefComplaintId = Number(this.$route.params.id);
      this.getAllAdviceGuidance(this.chiefComplaintId);
      this.getChiefComplaintFunction(this.chiefComplaintId);
    },
  },
};
</script>
<template>
  <app-page-container title="توصیه و راهنمایی">
    <template v-slot:header>
      <v-col cols="1" class="mr-n11">
        <v-btn class="mt-3" fab dark small @click="backToChiefComplaintPage()" color="darkColor" elevation="0">
          <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="3">
        <div class="mt-5 primary-color">
          {{ chiefComplaint.title }}
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="4" class="ml-n16">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="3" class="text-left">
        <v-btn v-if="accessDenyAddEditChief" rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
          class="mt-3 normal-letter-spacing ml-3">
          <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
          افزودن
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row class="clinical-triage-container px-12">
        <v-col cols="12" v-for="{ id, ...rest } in filterdAllClinicalTriages" :key="id">
          <triage-card v-bind="rest" @click:delete="showDeleteConfirmFunction(id)"
            :accessDenyAddEditChief="accessDenyAddEditChief" @click:edit="enableAddEditFunction(2, id)"
            @click:changeStatus="changeAdviceStatus(rest?.status ? 2 : 1, id)"></triage-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <confirm-dialog ref="confirm">
          <v-row slot="action" no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
              style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
              بله
            </v-btn>
            <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
              @click="confirmDialogCancelFunction()">
              خیر
            </v-btn>
          </v-row>
        </confirm-dialog>
        <v-dialog width="400" v-model="showAddEditModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">{{ modalIcon }}</v-icon>
                  <span class="modal-title-text mr-2">{{ modalTitle }}</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-textarea outlined label="توضیحات*" clearable clear-icon="mdi-close-circle-outline"
                    v-on:keyup.enter="showConfirmDialogFunction()" class="input-label"
                    prepend-inner-icon="mdi-text-box mdi-18px" tabindex="1" :autofocus="true" rows="4" type="text"
                    v-model="chiefComplaintAdvice.note"></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete :items="clinicalTriagepriority" no-data-text="اطلاعاتی وجود ندارد" outlined
                    label="اولویت" clearable clear-icon="mdi-close-circle-outline" autocomplete="off"
                    v-model="chiefComplaintAdvice.priority" prepend-inner-icon="mdi-subtitles mdi-20px"
                    tabindex="2"></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
      <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
        :snakIcon="snakIcon"></alert-component>
    </template>
  </app-page-container>
  <!-- <div>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img
                :src="tableTitleImage.val"
                contain
                max-height="14vh"
                max-width="27vh"
              >
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content"
                      >مدیریت توصیه/راهنما</span
                    >
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table
                          :headers="
                            clinicalTriageManagmentInformationTableHeaders
                          "
                          :items="clinicalTriageFilteredList"
                          :items-per-page="clinicalTriageFilteredList.length"
                          height="68vh"
                          :hide-default-footer="true"
                          multi-sort
                          class="elevation-0"
                        >
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  class="mt-1"
                                  color="iconColor"
                                  style="cursor: pointer"
                                  @click="enableAddEditFunction(2, item.id)"
                                  v-bind="attrs"
                                  v-on="on"
                                  >mdi-pencil</v-icon
                                >
                              </template>
                              <span>ویرایش</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  class="mt-1 mr-5"
                                  color="iconColor"
                                  style="cursor: pointer"
                                  @click="showDeleteConfirmFunction(item.id)"
                                  v-bind="attrs"
                                  v-on="on"
                                  >mdi-delete</v-icon
                                >
                              </template>
                              <span>حذف</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
  </div> -->
</template>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.clinical-triage-container {
  overflow-y: auto !important;
  max-height: 80vh;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
